import { combineReducers } from 'redux';

import { reducer as uploading } from './State/uploading';

export default combineReducers({
  uploading
})
